<template>
    <div :class="'page-component-' + (component || 'unknown').toLowerCase()" class="page-component-wrapper">
        <div class="page-component">
            <h1 v-if="showTitle && title">{{ title }}</h1>
            <p class="description" v-if="showDescription && description">{{ description }}</p>

            <component
                    :class="'page-component-' + componentLowerCase + ' side-' + side"
                    :description="description"
                    :is="'PageComponent' + component"
                    :options="options"
                    :side="side"
                    :title="title"
                    class="page-component"
                    v-on:pickChoice="onPickChoice"
            />

            <div class="footer-button-container" v-if="showButtons">
                <app-button buttonType="back" v-if="showBackButton" v-on:click.native="onClickBack ">{{ backButtonText
                    }}
                </app-button>
                <app-button v-if="showContinueButton" v-on:click.native="onClickContinue ">{{ continueButtonText }}
                </app-button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    import PageComponentChoices from './choices'
    import PageComponentFullMedia from './full-media'
    import PageComponentRawMedia from './raw-media'
    import PageComponentPhone from './phone'
    import PageComponentPoints from './points'
    import PageComponentText from './text'
    import PageComponentWinScreen from './win-screen'
    import PageComponentResults from './results'

    import AppButton from '@/components/app-button';
    import AppConfig from '@/app-config'
    import GameType from '../../enum/GameType'

    export default {
        name: 'page-component',
        components: {
            PageComponentChoices,
            PageComponentFullMedia,
            PageComponentRawMedia,
            PageComponentPhone,
            PageComponentPoints,
            PageComponentText,
            PageComponentWinScreen,
            PageComponentResults,
            AppButton
        },
        props: {
            side: {
                type: String,
                required: true
            },
            component: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: false
            },
            description: {
                type: String,
                required: false
            },
            options: {
                type: Object,
                required: false,
                default() {
                    return {};
                }
            }
        },
        computed: {
            ...mapGetters({
                gameType: 'getGameType',
                currentCase: 'getCurrentCase',
                actualCurrentPageIndex: 'getCurrentPageIndex',
            }),

            instantSelection() {
                return this.gameType === GameType.SinglePlayer && this.component === 'Choices';
            },

            componentLowerCase() {
                return this.component.toLowerCase();
            },
            showContinueButton() {
                if (!this.isLeftOrFull) {
                    return false;
                }

                return this.componentSupport.continueButton;
            },
            backButton() {
                if (this.isLeftOrFull && this.options && this.options.hasOwnProperty('backButton') && this.options.backButton) {
                    return this.options.backButton;
                }

                return null;
            },
            backButtonIndex() {
                if (this.isLeftOrFull && this.options && this.options.hasOwnProperty('backButtonIndex') && this.options.backButtonIndex) {
                    return this.options.backButtonIndex;
                }

                return null;
            },
            showBackButton() {
                return !!this.backButton || this.backButtonIndex !== null;
            },
            showButtons() {
                if (this.instantSelection) {
                    return false; // There's instant selection, so we don't need to show the button here
                }

                return this.showContinueButton || this.showBackButton;
            },
            showTitle() {
                return this.isLeftOrFull ? this.componentSupport.title : false;
            },
            showDescription() {
                return this.isLeftOrFull ? this.componentSupport.description : false;
            },
            componentSupport() {
                if (!AppConfig.componentSupport.hasOwnProperty(this.component)) {
                    throw new Error(`Could not find component support for ${this.component}`);
                }

                return AppConfig.componentSupport[this.component];
            },
            isLeftOrFull() {
                return this.side === 'left' || this.side === 'full';
            },
            isLastPage() {
                return this.actualCurrentPageIndex >= this.currentCase.pages.length - 1;
            },
            continueButtonText() {
                return this.isLastPage ? 'Afslut' : 'Videre';
            },
            backButtonText() {
                return 'Vælg om';
            }
        },
        methods: {
            emitContinue() {
                if (this.isLastPage) {
                    this.$emit('end');
                } else {
                    this.$emit('continue');
                }
            },
            onClickContinue() {
                this.emitContinue();
            },
            onClickBack() {
                if (this.backButtonIndex) {
                    this.$emit('goBack', this.backButtonIndex);
                } else {
                    this.$emit('goBack', this.backButton);
                }
            },
            onPickChoice(choice) {
                this.$emit('pickChoice', choice);
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/variables.less";

    .footer-button-container {
        text-align: center;
    }

    .description {
        white-space: pre-line;
    }
</style>